export default "__VITE_ASSET__2c6f8067__"